// window.onload = () =>{
// window.addEventListener("DOMContentLoaded", function() {

$(document).ready(function(){

    // alert('hola')
    // FUNCTIONS

    const filterLocation = () => {
        const location = window.location.href
        const splitLocation = location.split('/')
        const last = splitLocation.pop();
        const splitRoute = last.split('.');
        if(splitRoute[0] != 'index' && splitRoute[0] != ''){
            return last
        }
        return false;
    }
    
    const filterElements = (page, condition) => {
        const elements = document.querySelectorAll('a');
        let newElements = Array.prototype.slice.call(elements)
    
        return newElements.filter( (element) => {
            const split = element.href.split('/');
            let param = split.pop();
            if(param === page && element.classList[0] == condition){
                return element;
            }
        });
    }
    
    const activateLink = (element) => {
    
        const link = element[0];
    
        if(link){
            if(link.parentElement.parentElement.classList[0] == 'sub-items'){
                link.parentElement.parentElement.style.display = 'block'
                link.style.fontWeight = 'bold'
            }
    
            if(link.parentElement.parentElement.parentElement.parentElement.classList[0] == 'sub-items'){
                link.parentElement.parentElement.parentElement.parentElement.style.display = 'block';   
            }
        }
    
    
    }
    
    const desactivatedLinks = () => {
        const elements = document.querySelectorAll('a');
        let newElements = Array.prototype.slice.call(elements)
        newElements.forEach(element => {
            element.style = ''
        });
    }
    
    const saveLinkVisited = () => {
    
    }
    
    const getLinkVisited = () => {
    
    }
    
    const activatedModal = () => {
    
    }
    
    const addLinkVisited = (link) => {
        localStorage.setItem('visitedLink', link);
    }
    
    const deleteLinkVisited = () => {
        const visitedLink = localStorage.getItem('visitedLink');
        if(visitedLink){
            localStorage.removeItem('visitedLink');
        }
        // console.log(visitedLink);
    }
    
    
    const scrollViewSection = () => {
        const location = window.location.href
        const split = location.split('#');
        const sectionId = split.pop();
    
        if(split.length && sectionId != ''){
            const section = document.getElementById(sectionId)
            if(section){
                // section.scrollIntoView({
                //     alignTo: true,
                //     behavior: 'smooth'
                // });
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(`#${sectionId}`).offset().top
                }, 500);
            }
        }
    }
    
    const hideMenu = () => {
        $('#close_navigation').trigger('click');
    }
    
    
    
    
    // DECLARATIONS
    
    const location = filterLocation();
    const backBtn   = document.getElementById('backBtn');
    
    if(location){
        const element = filterElements(location, 'sub-item__link');
        activateLink(element);
        deleteLinkVisited();
        addLinkVisited(location);
    }
    
    const modals = document.querySelectorAll('.cards-yela-modals')
    const visitedLink = localStorage.getItem('visitedLink');
    const ele = filterElements(visitedLink, 'd-group')
    // console.log(ele[0].parentElement.parentElement.parentElement.parentElement)
    
    
    // EVENTS
    
    // window.onhashchange = function() { 
    //     scrollViewSection();
    //     const location = filterLocation();
    //     if(location){
    //         const element = filterElements(location, 'sub-item__link');
    //         desactivatedLinks();
    //         activateLink(element);
    //         hideMenu();
    //     }
    // }
    $(window).bind( 'hashchange', function(e) { 
        scrollViewSection();
        const location = filterLocation();
        if(location){
            const element = filterElements(location, 'sub-item__link');
            desactivatedLinks();
            activateLink(element);
            hideMenu();
        }
    });

})


// }
// )

